module.exports = __webpack_public_path__ + "img/title.11417166.png";